export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-edit-b6acec38e6dd74501aad173d73146168.svg";